import React from 'react';
import api from '../services/api';

const DebugPage = () => {
    return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
            <h2>Debug Information</h2>
            <div>
                <h3>Environment Variables:</h3>
                <p>NODE_ENV: {process.env.NODE_ENV}</p>
                <p>REACT_APP_API_URL: {process.env.REACT_APP_API_URL || 'undefined'}</p>
                
                <h3>API Configuration:</h3>
                <p>API baseURL: {api.defaults.baseURL}</p>
                
                <h3>Test API Call:</h3>
                <button onClick={async () => {
                    try {
                        console.log('Testing API call to /api/topics/');
                        const response = await api.get('/api/topics/');
                        console.log('API call successful:', response.data);
                        alert('API call successful - check console for details');
                    } catch (error) {
                        console.error('API call failed:', error);
                        alert(`API call failed: ${error.message}`);
                    }
                }}>
                    Test API Call
                </button>
            </div>
        </div>
    );
};

export default DebugPage;
